import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getSpotGoldProductDetailsApi = createAsyncThunk(
  "spotGoldProductDetails",
  async (id) => {
    const response = await axiosInstance.get(`/product/${id}`);
    // const response = await axiosInstance.get(`/category/product/${id}`);
    return response.data;
  }
);

const spotGoldProductDetailsSlice = createSlice({
  name: "spotGoldProductDetails",
  initialState: {
    spotGoldProductDetails: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSpotGoldProductDetailsApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSpotGoldProductDetailsApi.fulfilled, (state, action) => {
        state.spotGoldProductDetails = action.payload;
        state.loading = false;
      })
      .addCase(getSpotGoldProductDetailsApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default spotGoldProductDetailsSlice.reducer;
